/**
 * Configuration settings for the Data Shop application.
 */

// Backend URL - if empty string, use relative URLs (same origin)
// This allows nginx to proxy /api/ requests to the backend
const getBackendUrl = (): string => {
  const envUrl = import.meta.env.VITE_BACKEND_URL;

  // If explicitly set (including empty string), use that value
  if (envUrl !== undefined) {
    // Security: If we're on HTTPS but env URL is HTTP (not localhost), force relative URLs
    // This prevents mixed content errors from misconfigured builds
    if (
      typeof window !== 'undefined' &&
      window.location.protocol === 'https:' &&
      envUrl &&
      envUrl.startsWith('http://') &&
      !envUrl.includes('localhost')
    ) {
      console.warn(
        '[Settings] Mixed content detected: HTTPS page with HTTP backend URL. Using relative URLs instead.',
        { configuredUrl: envUrl }
      );
      return '';
    }
    return envUrl;
  }

  // Default for development
  return 'http://localhost:9000';
};

export const BACKEND_URL = getBackendUrl();

export const API_ENDPOINTS = {
  auth_login: '/api/v1/auth/login',
  auth_logout: '/api/v1/auth/logout',
  auth_verify: '/api/v1/auth/verify',
  auth_captcha: '/api/v1/auth/captcha',
  auth_csrf_token: '/api/v1/auth/csrf-token',
  google_oauth_login: '/api/v1/auth/google/login',
  google_oauth_status: '/api/v1/auth/google/status',
  users_me: '/api/v1/users/me',
  users_roles: '/api/v1/users/me/roles',
  datasets: '/api/v1/datasets',
  orders: '/api/v1/orders/',
  create_order: '/api/v1/orders/',
  request_phone_verification: '/api/v1/orders/{order_id}/verify-phone',
  confirm_phone_verification: '/api/v1/orders/{order_id}/verify-phone/confirm',
  user_phone_verification: '/api/v1/users/me/verify-phone',
  user_phone_verification_confirm: '/api/v1/users/me/verify-phone/confirm',
  bug_report: '/api/v1/bugs/report',
  // Admin endpoints
  admin_users: '/api/v1/admin/users',
  admin_user: '/api/v1/admin/users',
  admin_groups: '/api/v1/admin/groups',
  admin_group: '/api/v1/admin/groups',
  admin_roles: '/api/v1/admin/roles',
  ADMIN_ASSOCIATIONS: '/api/v1/admin/associations',
  // Access Control endpoints
  access_control_my_rights: '/api/v1/access-control/my-rights',
  access_control_refresh: '/api/v1/access-control/refresh-access',
} as const;

export const DEFAULT_PAGE_SIZE = 10;
export const MAX_PAGE_SIZE = 100;

export const JWT_EXPIRES_MINUTES = parseInt(
  import.meta.env.VITE_JWT_EXPIRES_MINUTES || '30',
  10
);
export const JWT_REFRESH_THRESHOLD_MINUTES = parseInt(
  import.meta.env.VITE_JWT_REFRESH_THRESHOLD_MINUTES || '5',
  10
);

export const LOG_LEVEL = import.meta.env.VITE_LOG_LEVEL || 'INFO';
